<template>
  <div>
    <v-card>
      <v-toolbar color="transparent" flat>
        <v-toolbar-title>Documentação</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="create">
          <v-icon>add</v-icon>
        </v-btn>
      </v-toolbar>
      <v-layout px-4 wrap>
        <v-flex md12>
          <v-list two-line>
            <template v-for="(item, i) in data">
              <v-divider v-if="i > 0" :key="`divider_${item.id}`"></v-divider>
              <v-list-item ripple :key="`tile_${item.id}`" @click="load(item)">
                <v-list-item-content>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-tooltip max-width="350" left>
                    <template v-slot:activator="{ on }">
                      <v-icon color="grey lighten-1" v-on="on">info</v-icon>
                    </template>
                    <span>{{ item.description }}</span>
                  </v-tooltip>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list>
        </v-flex>
      </v-layout>
    </v-card>
    <v-dialog v-model="isAddOnFormVisible" persistent max-width="800px">
      <v-card>
        <v-card-title class="headline">Opcional</v-card-title>
        <v-container grid-list-xs>
          <v-layout wrap>
            <v-flex md9>
              <v-text-field
                name="name"
                label="Nome"
                id="name"
                v-model="formModel.name"
                required
              ></v-text-field>
            </v-flex>
            <v-flex md3>
              <v-checkbox
                name="isMandatory"
                label="Obrigatório"
                id="isMandatory"
                v-model="formModel.isMandatory"
              ></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex md12>
              <v-textarea
                name="description"
                label="Descrição"
                id="description"
                v-model="formModel.description"
                required
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-btn icon @click="confirmDelete" v-if="this.formModel.id > 0">
            <v-icon>delete</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="cancel">Cancelar</v-btn>
          <v-btn color="primary" text @click="save">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <OperationStatusCard
      ref="loadingStatusCard"
      progressMessage="Carregando"
      successMessage="Pronto"
      errorMessage="Falha ao carregar"
    />
    <OperationStatusCard
      ref="executingStatusCard"
      progressMessage="Operação em progresso"
      successMessage="Pronto"
      errorMessage="Falha ao executar operação"
    />
    <ConfirmDialog
      id="confirmDeleteDialog"
      ref="confirmDeleteDialog"
      title="Excluir Registro"
      :message="`Deseja realmente excluir o documento ${this.formModel.name}?`"
      yes-button="Sim"
      no-button="Não"
      @confirm="this.delete"
    />
  </div>
</template>
<script>
import api from "@/api";
import ConfirmDialog from "@/components/Shared/ConfirmDialog";
import OperationStatusCard from "@/components/Shared/OperationStatusCard";
export default {
  name: "DocumentCheckManagement",
  components: {
    ConfirmDialog,
    OperationStatusCard
  },
  props: ["tripId"],
  data() {
    return {
      isDataLoading: false,
      isAddOnFormVisible: false,
      formModel: {},
      data: []
    };
  },
  methods: {
    create() {
      this.formModel = {};
      this.isAddOnFormVisible = true;
    },
    save() {
      this.$refs.executingStatusCard.show();
      var endpoint = this.formModel.id
        ? `/trips/${this.tripId}/documentCheck/${this.formModel.id}`
        : `/trips/${this.tripId}/documentCheck`;
      var method = this.formModel.id ? "PUT" : "POST";
      api
        .request(method, endpoint, this.formModel)
        .then(() => {
          this.$refs.executingStatusCard.succeed();
          this.isAddOnFormVisible = false;
          this.loadAll();
        })
        .catch(error => {
          this.$refs.executingStatusCard.fail(error.response.data);
        });
    },
    delete() {
      this.$refs.executingStatusCard.show();
      api
        .request(
          "DELETE",
          `/trips/${this.tripId}/documentCheck/${this.formModel.id}`
        )
        .then(() => {
          this.$refs.executingStatusCard.succeed();
          this.isAddOnFormVisible = false;
          this.loadAll();
        })
        .catch(error => {
          this.$refs.executingStatusCard.fail(error.response.data);
        });
    },
    confirmDelete() {
      this.$refs.confirmDeleteDialog.show();
    },
    cancel() {
      this.isAddOnFormVisible = false;
      this.loadAll();
    },
    load(addOn) {
      this.formModel = addOn;
      this.isAddOnFormVisible = true;
    },
    loadAll() {
      if (this.tripId) {
        this.isDataLoading = true;
        api
          .request("GET", `/trips/${this.tripId}/documentCheck`)
          .then(response => {
            this.data = response.data.documentChecks;
            this.$emit("loaded", this.data);
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
            this.isDataLoading = false;
          });
      }
    }
  },
  mounted() {
    this.loadAll();
  }
};
</script>
